import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { getUserCards } from '../../actions/userActions';
import { connect } from 'react-redux';
import charges from '../../static/charges.json';
import OneTimeIcon from '../../images/OneTimeIcon.png';
import { runOneTimeCheck } from '../../actions/orderActions';
import config from '../../common/config';
import enums from '../../common/enums';
import ToastService from '../Toasts/toastService';
import ApiHelper from '../../api/apiCallsHelper.js';
import { getAuthorizedAuths, addSubjectAuth } from '../../actions/authorizationActions';
import UserApi from '../../api/user-api';
import Loader from '../Spinners/spinnerPage.jsx';
import { Alert, OverlayTrigger, Tooltip } from 'react-bootstrap';

const searchTypes = ['Federal', 'Local (Statewide or County)'];

class OneTimeCheckPopUp extends Component {
  constructor(props) {
    super(props);
    this.submitOrder = this.submitOrder.bind(this);
    this.handleChangeAuth = this.handleChangeAuth.bind(this);
    this.getServiceIdAndFees = this.getServiceIdAndFees.bind(this);
    this.state = {
      userId: '',
      courtFee: 0,
      serviceType: process.env.REACT_APP_TRUE_FINGERPRINTS_COUNTY_SERVICE_ID,
      error: '',
      orders: '',
      authorization: '',
      searchType: searchTypes[0] 
    };    
  }

  getServiceIdAndFees(state, county) {
    let serviceTypeId = 0,
      courtFee = 0;
    if (state && county) {
      const subjectState = charges[state.split('-').pop()];
      serviceTypeId =
        subjectState['SearchType'] === 'County'
          ? process.env.REACT_APP_TRUE_FINGERPRINTS_COUNTY_SERVICE_ID
          : process.env.REACT_APP_TRUE_FINGERPRINTS_STATEWIDE_SERVICE_ID;

      const surcharge = subjectState['Surcharge'];
      courtFee = 0;
      if (surcharge === 'Yes') {
        const surchargeDetails = subjectState['Surcharge Details'];
        const surchargeDetails2 = subjectState['Surcharge Details 2'];

        if (surchargeDetails['All']) {
          courtFee = surchargeDetails['All'];
        } else if (surchargeDetails[county]) {
          courtFee = surchargeDetails[county];
        } else if (surchargeDetails2 && surchargeDetails2[county]) {
          courtFee = surchargeDetails2[county];
        }
      } else {
        courtFee = 0;
      }
    }
    this.setState({ serviceType: serviceTypeId, courtFee: courtFee });
  }

  async componentDidMount() {
    let user = await UserApi.getUserWithJwt();
    if (user) {
      this.setState({
        user: user
      });
    }

    const req = {
      userId: user.Id
    }
    this.props.getAuthorizedAuths(req);

    try {
      let orders = await ApiHelper.postWithJWT(
        `${config.trueFingerPrintsAPI.baseURL}/orders/orders-limit`);

      this.setState({
        orders: orders.data.count
      });

      if (this.props.subjectDetails) {
        this.props.getSubjectDetails();
      }

      // if (!this.props.cards) {
      //   this.props.getUserCards();
      // }

      this.getServiceIdAndFees(this.props.state, this.props.county);
    } catch (err) { }
  }

  handleChangeAuth(e) {
    this.setState({ authorization: e.target.value});
    const isAuthUsedForFederalSearch = this.checkIsAuthUsedForFederalSearch(e.target.value);
    if(isAuthUsedForFederalSearch){
      this.setState({ searchType: 'Local (Statewide or County)'});
    }
  }

  checkIsAuthUsedForFederalSearch (authToken){
    if(this.props.authorizedAuths){
    const authorization = this.props.authorizedAuths.find(auth => auth.unique === authToken);    
    return authorization?.isUsedForFederalOrder;
    }
    return false;
  }

  async submitOrder() {
    try {
      const req = {
        amount:  this.state.courtFee * 100,
        subject_id: this.props.subjectId,
        source: this.state.cardToken,
        service_id: this.state.serviceType,
        orderTypeId: enums.OrderTypes.oneTimeCheck,
        auth: this.state.authorization,
        isLocalSearchType: this.state.searchType === 'Local (Statewide or County)'
      };
      await this.props.runOneTimeCheck(req);
      //store auth for subject
      const data = {
        userId: this.state.user.Id,
        auth: this.state.authorization,
        subject_id: this.props.subjectId,
      }
      this.props.addSubjectAuth(data);
      

      if (
        this.props.oneTimeCheckResult &&
        this.props.oneTimeCheckResult.status === 201
      ) {
        ToastService.show(
          'The order has been successfully sent for processing!',
          'success'
        );
        if(this.props.loadSubjects){
        this.props.loadSubjects();
        }
      }
      this.props.onHide();
    } catch (err) {
      if (err.response && err.response.status === 422) {
        ToastService.show(
          'PreHire is already in process for this subject',
          'error'
        );
        this.props.onHide();
      } else {
        //handle exception
        console.log('error', err);
        ToastService.show('Something went wrong, please contact customer support.', 'error');
      }
    }
  }

  showToast() {
    ToastService.show(
      'The order has been successfully sent for processing!',
      'success'
    );
  }
  

  render() {
    const isFederalDisabled = this.checkIsAuthUsedForFederalSearch(this.state.authorization);
    let button = null;
    let text = null;
    if ((parseInt(this.state.orders, 10) < parseInt(this.props.user.preHireLimit, 10)) || ((this.props.user.preHireLimit) === null)) {
      button = <Button onClick={this.submitOrder} disabled={!this.state.authorization.length} className='primary mx-3 mt-3'><i className='material-icons'>fingerprint</i>Initiate CourtRequest</Button>;
    } else {
      button = <small className='text-danger'>Account Limited - This account does not have an active plan and can not issue PreHire check. For new accounts, you must go through compliance review and then activate a plan. If you previously had an active plan, you've reached your limit. Please contact Personnelgraph support.</small>
    }
    return (
      <Modal
        className='px-5'
        show={this.props.show}
        size='lg'
        aria-labelledby='contained-modal-title-vcenter'
        centered
        onHide={this.props.onHide}
      >
        <Modal.Header closeButton>
          <Modal.Title id='contained-modal-title-vcenter'>
            <figure className='icon-group mt-3'>
              <img src={OneTimeIcon} alt='One-Time Check Icon' />
              <h3 className='heading ml-3 mt-3'>Initiate CourtRequest</h3>
            </figure>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4 className='mb-4 mt-2'>Please select your authorization method:</h4>
          <Form.Group controlId='exampleForm.ControlSelect11' className='mb-4'>
          <Form.Label>Authorization</Form.Label>
          <Form.Control 
              as='select' 
              onChange={this.handleChangeAuth} 
              defaultValue={"no-data"} 
              disabled={!this.props.authorizedAuths || this.props.authorizedAuths.length === 0}
            >
              <option disabled value={"no-data"}>
                {!this.props.authorizedAuths || this.props.authorizedAuths.length === 0 
                  ? "No Authorization Found"
                  : "Select an Authorization"}
              </option>
              {this.props.authorizedAuths && this.props.authorizedAuths.length > 0
                ? this.props.authorizedAuths.map(a => (
                    <option key={a.unique} value={a.unique}>
                      {a.firstName} {a.lastName} - {a.unique} {a.isManual && "- (Manual)"}
                    </option>
                  ))
                : null}
            </Form.Control>
          </Form.Group>
          <Form.Label className='d-block'>Search type</Form.Label>
            <OverlayTrigger
              placement="top"
              delay={{ show: 150, hide: 200 }}
              overlay={(isFederalDisabled ?
                <Tooltip className='federal-tooltip'>
                  Federal check already done for this individual!
                </Tooltip> : <span></span>
              )}
            >
              <Form.Group controlId="Federal" className='d-inline-block'>
              <Form.Check
                key={'Federal'}
                type={'radio'}
                id={'Federal'}
                label={'Federal'}
                name="searchType"
                className='mb-1'
                disabled={isFederalDisabled}
                checked={this.state.searchType === 'Federal'}
                onChange={() => this.setState({...this.state, searchType: 'Federal' })}
              />
              </Form.Group>
            </OverlayTrigger>
            <Form.Check
            key={'Local (Statewide or County)'}
            type={'radio'}
            label={'Local (Statewide or County)'}
            id={'Local (Statewide or County)'}
            name="searchType"
            className='mb-1'
            checked={this.state.searchType === 'Local (Statewide or County)'}
            onChange={() => this.setState({...this.state, searchType: 'Local (Statewide or County)' })}
          />
          <Alert key={'success'} variant='success'> Powered by CourtScopeAI: Personnelgraph uses AI to intelligently select the appropriate courts for each Individual Profile, ensuring the broadest search coverage and reducing the risk of missing criminal records due to gaps in state or county repositories.</Alert>
          <Form.Group controlId='exampleForm.ControlSelect1'>       
            {this.state.error ? <p className='text-danger'>{this.state.error}</p> : null}
            <Form.Label className='mt-2'>
              {' '}
              Court Fee Surcharge: ${this.state.searchType === "Federal" ? "2.75" : this.state.courtFee}
            </Form.Label>
            {/*}  <br />
            <Form.Label>
              {' '}
              PreHire Fee $: {config.OrderFees.OneTimeCheck}
            </Form.Label>*/}
            <br />
            {/* <Form.Label>
              PreHire Charge: 
                ${this.props.user.preHireCharge}
            </Form.Label>
            <br />
            <Form.Label>
              {' '}
              Total Charge: 
                ${this.state.courtFee + parseInt(this.props.user.preHireCharge, 10)}
            </Form.Label> */}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          {text}
          {this.state.orders === "" ? <Loader/> : button}
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapActionsToProps = {
  getUserCards: getUserCards,
  runOneTimeCheck: runOneTimeCheck,
  getAuthorizedAuths: getAuthorizedAuths,
  addSubjectAuth: addSubjectAuth
};

const mapStateToProps = state => {
  return {
    cards: state.userReducer.cards,
    oneTimeCheckResult: state.orderReducer.oneTimeCheckResult,
    authorizedAuths: state.authorizationReducer.authorizedAuthList || []
  };
};

export default connect(mapStateToProps, mapActionsToProps)(OneTimeCheckPopUp);
